var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.btnType === "staticBtn"
    ? _c("div", { staticClass: "container-btn-blue" }, [
        _vm.helperMainBlueText
          ? _c("p", { staticClass: "text-medium helper-text" }, [
              _vm._v(_vm._s(_vm.helperMainBlueText)),
            ])
          : _vm._e(),
        _c(
          "button",
          {
            staticClass: "btn mainBlue",
            attrs: {
              disabled: _vm.shouldBeDisabled || _vm.mainBlueShouldBeDisabled,
            },
          },
          [_c("p", { staticClass: "text-medium" }, [_vm._v(_vm._s(_vm.title))])]
        ),
      ])
    : _vm.btnType === "functionalBtn"
    ? _c(
        "div",
        { staticClass: "container-btn-blue" },
        [
          _vm.helperMainBlueText
            ? _c("p", { staticClass: "text-medium helper-text" }, [
                _vm._v(_vm._s(_vm.helperMainBlueText)),
              ])
            : _vm._e(),
          _c(
            "button",
            {
              staticClass: "btn mainBlue",
              attrs: {
                disabled: _vm.shouldBeDisabled || _vm.mainBlueShouldBeDisabled,
              },
              on: { click: _vm.handleButtonClick },
            },
            [
              _c("p", { staticClass: "text-medium" }, [
                _vm._v(_vm._s(_vm.title)),
              ]),
            ]
          ),
          _vm._t("default"),
        ],
        2
      )
    : _vm.btnType === "spinnerBtn"
    ? _c("div", { staticClass: "container-btn-blue" }, [
        _vm.helperMainBlueText
          ? _c("p", { staticClass: "text-medium helper-text" }, [
              _vm._v(_vm._s(_vm.helperMainBlueText)),
            ])
          : _vm._e(),
        _c(
          "button",
          {
            staticClass: "btn mainBlue",
            attrs: { disabled: "true" },
            on: { click: _vm.handleButtonClick },
          },
          [_c("maSpinner")],
          1
        ),
      ])
    : _vm.btnType === "startBtn"
    ? _c("div", { staticClass: "container-btn-blue" }, [
        _vm.helperMainBlueText
          ? _c("p", { staticClass: "text-medium helper-text" }, [
              _vm._v(_vm._s(_vm.helperMainBlueText)),
            ])
          : _vm._e(),
        _c(
          "button",
          { staticClass: "btn mainBlue", on: { click: _vm.handleButtonClick } },
          [_c("p", { staticClass: "text-medium" }, [_vm._v(_vm._s(_vm.title))])]
        ),
      ])
    : _vm.btnType === "functionalBtnWhite"
    ? _c(
        "div",
        { staticClass: "container-btn-blue" },
        [
          _vm.helperMainBlueText
            ? _c("p", { staticClass: "text-medium helper-text" }, [
                _vm._v(_vm._s(_vm.helperMainBlueText)),
              ])
            : _vm._e(),
          _c(
            "button",
            {
              staticClass: "btn mainBlue mg mg--b-2",
              class: _vm.classBtnExtra,
              attrs: {
                disabled: _vm.shouldBeDisabled || _vm.mainBlueShouldBeDisabled,
              },
              on: { click: _vm.handleButtonClick },
            },
            [
              _c("p", { staticClass: "text-medium" }, [
                _vm._v(_vm._s(_vm.title)),
              ]),
            ]
          ),
          _vm.helperMainWhiteText
            ? _c("p", { staticClass: "text-medium helper-text" }, [
                _vm._v(_vm._s(_vm.helperMainWhiteText)),
              ])
            : _vm._e(),
          _c(
            "button",
            {
              staticClass: "btn mainWhite",
              class: _vm.classBtnExtra,
              attrs: {
                disabled: _vm.shouldBeDisabled || _vm.mainWhiteShouldBeDisabled,
              },
              on: { click: _vm.handleButtonClickWhiteBtn },
            },
            [
              _c("p", { staticClass: "text-medium" }, [
                _vm._v(_vm._s(_vm.titleWhiteBtn)),
              ]),
            ]
          ),
          _vm._t("default"),
        ],
        2
      )
    : _vm.btnType === "onlyFunctionalBtnWhite"
    ? _c("div", { staticClass: "container-btn-blue" }, [
        _vm.helperMainWhiteText
          ? _c("p", { staticClass: "text-medium helper-text" }, [
              _vm._v(_vm._s(_vm.helperMainWhiteText)),
            ])
          : _vm._e(),
        _c(
          "button",
          {
            staticClass: "btn mainWhite",
            class: _vm.classBtnExtra,
            attrs: {
              disabled: _vm.shouldBeDisabled || _vm.mainWhiteShouldBeDisabled,
            },
            on: { click: _vm.handleButtonClickWhiteBtn },
          },
          [
            _c("p", { staticClass: "text-medium" }, [
              _vm._v(_vm._s(_vm.titleWhiteBtn)),
            ]),
          ]
        ),
      ])
    : _vm.btnType === "functionalBtnCounter"
    ? _c("div", { staticClass: "container-btn-blue" }, [
        _vm.helperMainBlueText
          ? _c("p", { staticClass: "text-medium helper-text" }, [
              _vm._v(_vm._s(_vm.helperMainBlueText)),
            ])
          : _vm._e(),
        _c(
          "button",
          {
            staticClass: "btn mainBlue",
            attrs: {
              disabled: _vm.shouldBeDisabled || _vm.mainBlueShouldBeDisabled,
            },
            on: { click: _vm.handleButtonClick },
          },
          [
            _c("p", { staticClass: "text-medium" }, [
              _vm._v(_vm._s(_vm.title)),
            ]),
            _c("p", { staticClass: "text-medium mg mg--l-1" }, [
              _vm._v("(" + _vm._s(_vm.total) + ")"),
            ]),
          ]
        ),
      ])
    : _vm.btnType === "non-fixedBtn"
    ? _c("div", { staticClass: "container-btn-non-fixed" }, [
        _vm.helperMainBlueText
          ? _c("p", { staticClass: "text-medium helper-text" }, [
              _vm._v(_vm._s(_vm.helperMainBlueText)),
            ])
          : _vm._e(),
        _c(
          "button",
          {
            staticClass: "btn mainBlue",
            attrs: {
              disabled: _vm.shouldBeDisabled || _vm.mainBlueShouldBeDisabled,
            },
            on: { click: _vm.handleButtonClick },
          },
          [_c("p", { staticClass: "text-medium" }, [_vm._v(_vm._s(_vm.title))])]
        ),
      ])
    : _vm.btnType === "non-fixedBtnWhite"
    ? _c("div", { staticClass: "container-btn-non-fixed" }, [
        _vm.helperMainBlueText
          ? _c("p", { staticClass: "text-medium helper-text" }, [
              _vm._v(_vm._s(_vm.helperMainBlueText)),
            ])
          : _vm._e(),
        _c(
          "button",
          {
            staticClass: "btn mainWhite",
            attrs: {
              disabled: _vm.shouldBeDisabled || _vm.mainBlueShouldBeDisabled,
            },
            on: { click: _vm.handleButtonClick },
          },
          [_c("p", { staticClass: "text-medium" }, [_vm._v(_vm._s(_vm.title))])]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }